import React from 'react'

import ActionIcon from '../Mantine/ActionIcon'

import * as S from './styles.js'

const SIZE_BLANK_SLATE = {
  lg: '100',
  md: '80',
  sm: '60'
}

export default function BlankSlate({
  icon,
  title,
  subTitle,
  size = 'lg',
  centralize = false,
  mt = null,
  mb = null,
  color = null
}) {
  return (
    <S.BlankSlateContainer centralize={centralize} marginTop={mt} color={color}>
      <S.BlankSlateWrapper>
        <S.Icon size={SIZE_BLANK_SLATE[size]} marginBottom={mb}>
          <ActionIcon
            alt="blankSlateIcon"
            variant="transparent"
            icon={icon}
            color={color}
          />
        </S.Icon>
        <S.Title size={SIZE_BLANK_SLATE[size]}>{title}</S.Title>

        <S.SubTitle size={SIZE_BLANK_SLATE[size]}>{subTitle}</S.SubTitle>
      </S.BlankSlateWrapper>
    </S.BlankSlateContainer>
  )
}
